<template>
  <div class="newhand">
    <div class="newhand-bg"></div>
    <div class="warper clearfix">
      <!-- 文案 -->
      <div class="newhand-text">
        <a-breadcrumb>
          <a-breadcrumb-item>
                <i class="iconfont icon-menu-home" style="color: #2b6afd;margin-right:5px"></i>
            <a href="/help">帮助中心</a></a-breadcrumb-item>
          <a-breadcrumb-item>快速上手</a-breadcrumb-item>
        </a-breadcrumb>
        <h1>新手入门</h1>
        <p>
          诺客云新手入门提供了各类产品使用说明文档，通过快速入门教程、实践案例、视频教程等各项操作指南，帮助用户更快的了解诺客云产品的使用
        </p>
      </div>
      <div class="newhand-bottom">
        <a-row type="flex" justify="space-between">
          <a-col :span="6" v-for="item in 4" key="index">
            <div class="cate-card">
                <div class="cate-img">
                </div>
                <div class="cate-name">应用案例</div>
                <div class="cate-nameline"></div>
                <div class="cate-info">这里是介绍这里是介绍</div>
                <div class="cateline" @click="goUrl">
                  <div class="title" v-for="item in 6" key="index">
                    <span class="tag">这里标签</span>1台NBR
                    6系的网关巴6系的网关巴6系的网关巴
                  </div>
                </div>
            </div>
          </a-col>
        </a-row>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      property: 'value',
    };
  },
  methods:{
    goUrl() {
      this.$router.push({ name: "releaseArticle", query: { id: 111 } });
    },
  }
};
</script>
<style scoped>
/* newhand */
.newhand {
  height: 100vh;
  padding-top: 68px;
  position: relative;
  background: linear-gradient(180.72deg, #deebff 0.69%, #ffffff 51.67%);
}
.newhand-text {
  padding-top: 2vh;
}
.newhand-text h1 {
  margin-top: 2rem;
  text-align: center;
  font-weight: 400;
  font-size: 36px;
  /* color: rgba(0, 0, 0, 0.65); */
}
.newhand-text p {
  text-align: center;
  font-size: 14px;

  color: rgba(0, 0, 0, 0.45);
}
/* newhand-bottom */
.newhand-bottom {
  margin-top: 5rem;
}

.cate-card {
  margin: 0.5rem;
  position: relative;
  background-color: #fff;
  height: 40vh;
  background: linear-gradient(
    180deg,
    rgba(240, 246, 255, 0.8) 0%,
    rgba(255, 255, 255, 0.8) 100%
  );
  box-shadow: -6px -6px 20px #ffffff, 6px 10px 25px #eceef3,
    inset 4px 4px 20px rgba(56, 78, 196, 0.05);
  backdrop-filter: blur(20px);
  /* Note: backdrop-filter has minimal browser support */

  border-radius: 6px;
  padding: 1rem;
  padding-top: 2rem;
}
.cate-card .cate-img {
  position: absolute;
  right: 1rem;
  top: 2rem;
}
.cate-card .cate-name {
  font-weight: 500;
  font-size: 18px;
  color: rgba(0, 0, 0, 0.9);
}
.cate-card .cate-nameline {
  margin: 0.5rem 0;
  width: 2rem;
  height: 3px;
  background-color: #2b6afd;
}
.cate-card .cate-info {
  font-size: 1rem;
  line-height: 2rem;
  color: rgba(0, 0, 0, 0.65);
  margin-bottom: 2rem;
}

.cate-card .cateline {
  cursor: pointer;
  font-size: 1rem;
  line-height: 2rem;
}

.cate-card .cateline .title {
  margin-top: 0.5rem;
  color: rgba(0, 0, 0, 0.65);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.cate-card .cateline .title:hover {
  color: #2b6afd;
}
.cate-card .cateline .tag {
  display: inline-block;
  padding: 2px 6px;
  background: linear-gradient(
    0deg,
    rgba(254, 255, 255, 0.6) 0%,
    rgba(255, 255, 255, 0.6) 100%
  );
  backdrop-filter: blur(14.7692px);
  /* Note: backdrop-filter has minimal browser support */

  border-radius: 4px;
  margin-right: 0.5rem;
}
</style>
